import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedSubscription: null, // The main plan user selected
    selectedAddons: [], // Array of addon objects
    cartItems: [], // If we support multiple items
    slotData: {
        selectedDate: null,
        selectedTime: null,
        selectedMealSlot: null, // "breakfast" | "lunch" | "dinner"
        mealSlotName: null, // "Breakfast" | "Lunch" | "Dinner"
    },
    checkoutTotal: 0,
    bookedData: null, // Store successful booking details
};

const foodSlice = createSlice({
    name: "food",
    initialState,
    reducers: {
        setSelectedSubscription: (state, action) => {
            state.selectedSubscription = action.payload;
        },
        setSelectedAddons: (state, action) => {
            state.selectedAddons = action.payload;
        },
        setSlotData: (state, action) => {
            state.slotData = action.payload;
        },
        addToCart: (state, action) => {
            // For now, simplify to single item flow like car wash often does initially
            state.selectedSubscription = action.payload.subscription;
            state.selectedAddons = action.payload.addons || [];
            state.checkoutTotal = action.payload.totalPrice;
        },
        setBookedData: (state, action) => {
            state.bookedData = action.payload;
        },
        clearCart: (state) => {
            state.selectedSubscription = null;
            state.selectedAddons = [];
            state.slotData = {
                selectedDate: null,
                selectedTime: null,
                selectedMealSlot: null,
                mealSlotName: null
            };
            state.checkoutTotal = 0;
            // NOTE: Do NOT clear bookedData here - it's needed for the thanks page
        },
    },
});

export const {
    setSelectedSubscription,
    setSelectedAddons,
    setSlotData,
    addToCart,
    clearCart,
    setBookedData
} = foodSlice.actions;

export default foodSlice.reducer;
